import type { FC } from 'react';
import styles from '../styles/booking-edit-select.module.scss';
import FormField from '../components/form-field';
import ActionButton from '../components/action-button';
import type { ExistingRepairBooking } from '../models/repair-bookings';
import { getTimeSlotString } from '../utils/helpers';
import AttentionBox from '../components/attention-box.tsx';

const BookingEditSelect: FC<{
    booking: ExistingRepairBooking;
    available: boolean;
    messages: string[];
    onSelectEdit: () => void;
    onSelectCancel: () => void;
}> = ({ booking, available, messages, onSelectEdit, onSelectCancel }) => {
    return (
        <div className={styles.bookingEditSelect}>
            {messages && <AttentionBox title="お客さまへのお知らせ" messages={messages} />}
            <div className={styles.title}>
                以下の予約を
                <br />
                変更／キャンセルできます
            </div>
            {booking.shop && booking.selectedSlot && (
                <>
                    <div className={styles.bookingForm}>
                        <FormField
                            readOnly={true}
                            inputType="text"
                            label="予約番号"
                            value={booking.confirmationId}
                        />
                        <FormField
                            readOnly={true}
                            inputType="text"
                            label="予約店舗"
                            value={booking.shop.name}
                        />
                        <FormField
                            readOnly={true}
                            inputType="text"
                            label="予約日時"
                            value={`${getTimeSlotString(booking.selectedSlot)}`}
                        />
                    </div>
                    {available && (
                        <div className={styles.actions}>
                            <ActionButton title="変更する" onClick={onSelectEdit} />
                            <ActionButton title="キャンセルする" onClick={onSelectCancel} />
                        </div>
                    )}
                </>
            )}
        </div>
    );
};

export default BookingEditSelect;
